import { BASE_ENDPOINT } from "../../endpoint";

/**
 * Confirms a wallet-funding invoice as paid, after a successful Paystack charge.
 *
 * @param {string} TOKEN - bearer auth token
 * @param {string|number} companyId
 * @param {{invoiceId:number, amountPaid:number, payrollPlan:string, reference:string}} payload
 * @returns {Promise<{status:string, message:string}>}
 */
export const completeFunding = async (TOKEN, companyId, payload) => {
  try {
    // --- DIAGNOSTIC LOGGING (remove after debugging) ---
    console.log("[completeFunding] payload:", payload);
    console.log("[completeFunding] payload types:", Object.fromEntries(
      Object.entries(payload).map(([k, v]) => [k, typeof v])
    ));
    console.log("[completeFunding] serialized:", JSON.stringify(payload));
    // ----------------------------------------------------

    const response = await fetch(
      `${BASE_ENDPOINT}/api/Wallets/${companyId}/complete-funding`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
        body: JSON.stringify(payload),
      },
    );
    const rawText = await response.text();
    console.log("[completeFunding] raw response:", rawText); // keep temporarily
    // ...rest unchanged
    let res = {};
    try {
      res = rawText ? JSON.parse(rawText) : {};
    } catch (parseErr) {
      console.error("Non-JSON response body:", rawText);
    }

    if (!response.ok) {
      console.error("Error:", res);
      throw new Error(
        res?.message ||
        `Failed to complete wallet funding (${response.status})`,
      );
    }
    // This endpoint does not return an updated balance — callers should
    // re-fetch getWalletInfo() after a successful call to refresh the UI.
    return res;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};
